import { UserSkill, UserSkillPayload } from 'api/users/models';

export function getSkillId(
  payloadSkill: UserSkillPayload,
  skills: UserSkill[],
) {
  return skills.find((skill) => skill.name === payloadSkill.name)?.id;
}
